module.exports = __webpack_public_path__ + "img/HIPAA.26ad7a57.png";